<!-- Section Pompe -->
<app-collapse [title]="'P0003601.parameters.status.rubrique.pompe' | translate">
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="
        'P0003601.parameters.status.statut.courantConsommeParLaPompe'
          | translate
      "
      [value]="(getValue('fvsSCourantConsommePompe') / 10).toFixed(1) + ' A'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003601.parameters.status.statut.vitesseReelle' | translate"
        [value]="getVitesseLabel(getValue('fvsSEtatVitesse'))"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.detectionFonctionnementPompe'
            | translate
        "
        [value]="
          getValue('fvsSFonctionnementPompe') === 0
            ? ('P0003601.parameters.status.statut.off' | translate)
            : ('P0003601.parameters.status.statut.on' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.puissanceApparente' | translate
        "
        [value]="getValue('fvsSPuissanceApparente') + ' VA'"
      />
    }

    <app-display-rubrique-status
      [title]="'P0003601.parameters.status.statut.puissanceActive' | translate"
      [value]="getValue('fvsSPuissanceActive') + ' W'"
    />
  </div>
</app-collapse>

<!-- Section Programme 72H -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003601.parameters.status.rubrique.programme72H' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeDeFiltration72H' | translate
        "
        [value]="getVitesseLabel(getValue('fvsSVitesseFiltration72h'))"
      />
    </div>
  </app-collapse>
}

<!-- Section Horloge -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003601.parameters.status.rubrique.horloge' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeDeFiltrationPPH' | translate
        "
        [value]="getVitesseLabel(getValue('fvsSVitesseFiltrationPPH'))"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeDeFiltrationPPE' | translate
        "
        [value]="getVitesseLabel(getValue('fvsSVitesseFiltrationPPE'))"
      />
    </div>
  </app-collapse>
}

<!-- Section Fonction Hors Gel -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003601.parameters.status.rubrique.fonctionHorsGel' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.temperatureReferenceDisponibleHorsGel'
            | translate
        "
        [value]="
          getValue('fvsSTemperatureReferenceDisponibleHorsGel') === 0
            ? ('P0003601.parameters.status.statut.temperatureReferenceDisponibleHorsGel.non'
              | translate)
            : ('P0003601.parameters.status.statut.temperatureReferenceDisponibleHorsGel.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeFiltrationPiloteHorsGel'
            | translate
        "
        [value]="getVitesseLabel(getValue('fvsSVitesseFiltrationHorsGel'))"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.mesureTemperatureHorsGel'
            | translate
        "
        [value]="getTemperature(getValue('fvsSMesureTemperatureHorsGel') / 10)"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.etatFonctionHorsGel' | translate
        "
        [value]="getValue('fvsSEtatFonctionHorsGel') !== 0"
      />
    </div>
  </app-collapse>
}

<!-- Section Fonction 24/24 -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003601.parameters.status.rubrique.fonction2424' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.temperatureReferenceDisponible2424'
            | translate
        "
        [value]="
          getValue('fvsSTemperatureReferenceDisponible2424') === 0
            ? ('P0003601.parameters.status.statut.temperatureReferenceDisponible2424.non'
              | translate)
            : ('P0003601.parameters.status.statut.temperatureReferenceDisponible2424.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeFiltrationPilote2424'
            | translate
        "
        [value]="getVitesseLabel(getValue('fvsSVitesseFiltration2424'))"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.mesureTemperature2424' | translate
        "
        [value]="getTemperature(getValue('fvsSMesureTemperature2424') / 10)"
      />
    </div>
  </app-collapse>
}

<!-- Section Asservissements -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003601.parameters.status.rubrique.asservissements' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeFiltrationAsservissement'
            | translate
        "
        [value]="
          getValue('fvsSAsservissement') === 0
            ? ('P0003601.parameters.status.statut.temperatureReferenceDisponible2424.non'
              | translate)
            : ('P0003601.parameters.status.statut.temperatureReferenceDisponible2424.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.pompeFiltrationFonctionEntreeAsservi'
            | translate
        "
        [value]="
          getVitesseLabel(getValue('fvsSVitesseFiltrationEntreeAsservie'))
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsserviePrioriteElectrolyseElectrolyseurStandard'
            | translate
        "
        [value]="
          getValue(
            'fvsSAsservissementFonctionPrioriteElectrolyseurStandard'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutoMaintienFiltrationElectrolyseurStandard'
            | translate
        "
        [value]="
          getValue(
            'fvsSAsservissementFonctionAutoMaintienElectrolyseurStandard'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionCL'
            | translate
        "
        [value]="
          getValue('fvsSAsservissementFonctionAutoMaintienInjectionCl') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P0003601.parameters.status.statut.entreeAsserviePrioriteElectrolyseElectrolyseurCellule'
              | translate
          )
        "
        [value]="
          getValue('fvsSAsservissementFonctionPrioriteElectrolyseurCellule') !==
          0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P0003601.parameters.status.statut.entreeAsservieBoostElectrolyseElectrolyseurCellule'
              | translate
          )
        "
        [value]="getValue('fvsSEntreeAsserviPrioriteBoostElectrolyseur') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P0003601.parameters.status.statut.entreeAsservieAutoMaintienFiltrationElectrolyseurCellule'
              | translate
          )
        "
        [value]="
          getValue(
            'fvsSAsservissementFonctionAutoMaintienElectrolyseurCellule'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPH'
            | translate
        "
        [value]="
          getValue('fvsSAsservissementFonctionAutoMaintienInjectionPh') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPAC'
            | translate
        "
        [value]="getValue('fvsSAsservissementFonctionAutoMaintienPAC') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPAC'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviFonctionPrioritePac') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutomaintienFiltrationInjectionPACWp'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviFonctionAutoMaintienPacWp') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPACWp'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviFonctionPrioritePacWp') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutomaintienFiltrationInjectionPACPoly'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviFonctionAutoMaintienPacPoly') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPACPoly'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviFonctionPrioritePacPoly') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieRedemarrageEclairageStandard'
            | translate
        "
        [value]="
          getValue('fvsSAsservissementFonctionRedemEclairageStandard') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieRedemarrageEclairageTunable'
            | translate
        "
        [value]="getValue('fvsSAsservissementFonctionRedemTunable') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsserviePrioriteRobot'
            | translate
        "
        [value]="getValue('fvsSAsservissementFonctionPrioriteRobot') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieAutoMaintienRobot'
            | translate
        "
        [value]="getValue('fvsSAsservissementFonctionAutoMaintienRobot') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieArretFiltrationVolet24'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviArretFiltrationVolet24') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003601.parameters.status.statut.entreeAsservieArretFiltrationVolet230'
            | translate
        "
        [value]="getValue('fvsSEntreeAsserviArretFiltrationVolet230') !== 0"
      />
    </div>
  </app-collapse>
}

<!-- Section Produit -->
<app-collapse
  [title]="'P0003601.parameters.status.rubrique.produit' | translate"
  [warning]="presenceProduit() === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P0003601.parameters.status.statut.tensionSecteur' | translate"
      [value]="getValue('fvsSTensionSecteur') + ' V'"
    />

    <app-display-rubrique-status-with-warning
      [title]="
        'P0003601.parameters.status.statut.presenceDuProduit' | translate
      "
      [warning]="presenceProduit() !== 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="
        'P0003601.parameters.status.statut.presenceDuProduit.ok' | translate
      "
    />

    <app-display-rubrique-status
      [title]="'P0003601.parameters.status.statut.tempsSousTension' | translate"
      [value]="transformHourToDayHourLocal(getValue('fvsSTempsSousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.compteurPuissanceActiveTotale'
            | translate
        "
        [value]="getValue('fvsSCompteurPuissanceActiveTotale') + ' Wh'"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.compteurAmpereHeure' | translate
        "
        [value]="getValue('fvsSCompteurAmpereHeure') + ' Ah'"
      />

      <app-display-rubrique-status-on-off
        [title]="'P0003601.parameters.status.statut.etatDuBouton' | translate"
        [value]="getValue('fvsSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.compteurDuBouton' | translate
        "
        [value]="getValue('fvsSCompteurBouton') + ''"
      />

      <app-display-rubrique-status
        [title]="
          'P0003601.parameters.status.statut.controleContacts' | translate
        "
        [value]="displayContacts(getValue('fvsSControleContacts'))"
      />
    }
  </div>
</app-collapse>
